import * as React from "react";

interface LoaderProps {
  color: string;
  className?: string;
  size?: number;
}

function Loader({ color, className, size = 24 }: LoaderProps) {
  return (
    <div
      className={`flex flex-row items-center justify-center ${className} w-full`}
    >
      <div
        className={`  animate-spin rounded-full border-2 border-t-transparent border-${color}`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderColor: `${color} transparent transparent transparent`,
        }}
      ></div>
    </div>
  );
}

export default Loader;
